import { useNetInfo } from '@react-native-community/netinfo'
import type { ReactNode } from 'react'

type TNetworkStatusProps = {
  children: (netInfo: ReturnType<typeof useNetInfo>) => ReactNode
}

export const NetworkStatus = ({ children }: TNetworkStatusProps) => {
  const netInfo = useNetInfo()

  return children(netInfo)
}
